// extracted by mini-css-extract-plugin
var _1 = "NotificationButton-module__animateUploadProgressBarWidth--neZXK";
var _2 = "NotificationButton-module__animatedBackground--pZrbH";
var _3 = "NotificationButton-module__buttonWrapper--el7AE";
var _4 = "NotificationButton-module__mobileOverlay--H1LwW";
var _5 = "NotificationButton-module__notificationButton--ReJzI";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "buttonWrapper", _4 as "mobileOverlay", _5 as "notificationButton" }
